// vim: ft=javascriptreact
import {
  Nav,
} from 'react-bootstrap'
import {
  Link,
  useLocation,
  Outlet,
} from 'react-router-dom'

const Admin = () => {
  const location = useLocation()

  let activeKey

  const path = location.pathname.split('/')
  const section = path[2]

  switch (section) {
    case 'residents':
    case 'bookings':
      activeKey = section
      break

    default:
      if (/residents/.test(location.pathname)) {
        activeKey = 'residents'
      }
  }

  return (
    <>
      <Nav variant="tabs" activeKey={activeKey} className="mb-3">
        <Nav.Item>
          <Nav.Link eventKey="bookings" to="/admin/bookings" as={Link}>Bookings</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="residents" to="/admin/residents" as={Link}>Residents</Nav.Link>
        </Nav.Item>
      </Nav>

      <Outlet />
    </>
  )
}

export default Admin
